import request from '@/utils/request'

export function list(query) {
    return request({
        url: '/level/list',
        method: 'get',
        params: query
    })
}

export function info(id) {
    return request({
        url: '/level/info/' + id,
        method: 'get'
    })
}

export function save(data) {
    return request({
        url: '/level/save',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: '/level/update',
        method: 'post',
        data
    })
}

export function remove(data) {
    return request({
        url: '/level/delete',
        method: 'post',
        data
    })
}

//查找所有级别
export function listAll() {
    let url = '/level/queryAll'
    let params = {order:'lv'}
    return request.get(url,{params})
}

